import { plural, singular } from 'pluralize';
import type { PlaceCollection, PlaceType } from '@placer-ui/types';

export const placeTypeToPlaceCollection = (type: PlaceType | undefined): PlaceCollection =>
    plural(type || '') as PlaceCollection;

export const placeCollectionToPlaceType = (collection: PlaceCollection | undefined): PlaceType =>
    singular(collection || '') as PlaceType;
